var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_c('i',{staticClass:"icon-ic_alert-red"}),_vm._v("\n    "+_vm._s(_vm.mensagem)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }